// src/lib/auth.js
export function saveAuth({ access, refresh, user }) {
  localStorage.setItem('access', access || '');
  localStorage.setItem('refresh', refresh || '');
  localStorage.setItem('user', JSON.stringify(user || null));
}

export function clearAuth() {
  localStorage.removeItem('access');
  localStorage.removeItem('refresh');
  localStorage.removeItem('user');
}

export function getAccess() {
  return localStorage.getItem('access') || '';
}

export function getRefresh() {
  return localStorage.getItem('refresh') || '';
}

export function getUser() {
  try { return JSON.parse(localStorage.getItem('user') || 'null'); }
  catch { return null; }
}

export function isLoggedIn() {
  return Boolean(getAccess());
}

export function hasRole(...roles) {
  const u = getUser();
  return !!u && roles.includes(u.role);
}

// ➕ util : met à jour l'utilisateur stocké (utile après /me)
export function saveUser(user) {
  localStorage.setItem('user', JSON.stringify(user || null));
}